import Text from "components/Brand/Text";
import React from "react";

function HowToPlay({ list }) {
  return (
    <>
      <Text
        fontSize="xl"
        color="var(--secondary-text-color)"
        as="ol"
        className="list-decimal pl-2"
      >
        {list?.length > 0 &&
          list.map((item, index) => {
            return <ListItem item={item} key={index} />;
          })}
      </Text>
    </>
  );
}

export default HowToPlay;

function ListItem({ item }) {
  if (typeof item === "string") {
    return <Text as="li">{item}</Text>;
  }
  const { title, description, items: childItems } = item;
  return (
    <>
      {title && <Text fontWeight={"bold"}>{title}</Text>}
      {description && <Text justify>{description}</Text>}
      <Text as="ol">
        {childItems?.length > 0 &&
          childItems.map((item, index) => (
            <Text key={index} as="li" textAlign="justify">
              {item}
            </Text>
          ))}
      </Text>
    </>
  );
}
